
<template>
  <div class="panel panel-default">
	<div class="panel-heading">
		<h4>更新日志</h4>
	</div>
	<div class="panel-body">
		<div class="row col-md-12">
			<div class="col-md-12">
				<ul class="timeline">
          <!-- timeline time label -->
  					<li class="time-label"><span class="bg-teal">
  							更新时间：2017-6-16 </span></li>
  					<li>
  						<!-- timeline icon --> <i class="fa fa-envelope bg-blue"></i>
  						<div class="timeline-item">
  							<span class="time"><i class="fa fa-clock-o"></i> 18:13</span>

  							<h3 class="timeline-header">
  								<a href="javascript:void(0)">CRM V3.3.0 更新日志</a>
  							</h3>
  							<div class="timeline-body">
  								1、新增-小宝客户管理页面<br/>
  								2、优化-我的审核流程<br/>
                  3、优化-任务管理（支持市场人员在后台查看自己的任务）<br/>
                  3、优化-维护记录<br/>
                  3、优化-数据概览<br/>
  							</div>
  							<div class="timeline-footer"></div>
  						</div>
  					</li>
  					<!-- END timeline item -->
          <!-- timeline time label -->
  					<li class="time-label"><span class="bg-red">
  							更新时间：2017-5-22 </span></li>
  					<li>
  						<!-- timeline icon --> <i class="fa fa-envelope bg-blue"></i>
  						<div class="timeline-item">
  							<span class="time"><i class="fa fa-clock-o"></i> 19:11</span>

  							<h3 class="timeline-header">
  								<a href="javascript:void(0)">CRM V3.2.0 更新日志</a>
  							</h3>
  							<div class="timeline-body">
  								1、新增-任务功能（包含任务发布及管理，及时跟进任务进度）<br/>
  								2、优化-客户推荐回访规则（引导用户完善、引导客户使用app、回访促活--工作分类更清晰）<br/>
  							</div>
  							<div class="timeline-footer"></div>
  						</div>
  					</li>
  					<!-- END timeline item -->
          <!-- timeline time label -->
  					<li class="time-label"><span class="bg-yellow">
  							更新时间：2017-4-27 </span></li>
  					<li>
  						<!-- timeline icon --> <i class="fa fa-envelope bg-blue"></i>
  						<div class="timeline-item">
  							<span class="time"><i class="fa fa-clock-o"></i> 19:11</span>

  							<h3 class="timeline-header">
  								<a href="javascript:void(0)">CRM V3.1.0 更新日志</a>
  							</h3>
  							<div class="timeline-body">
  								1、新增-修改客户资料<br/>
  								2、新增-小宝公告（战报+通知）<br/>
  								3、新增-后台操作记录<br/>
  								4、新增-员工管理（综合角色、地域等）<br/>
  								5、优化-推荐回访规则+支持再次签到<br/>
  								6、优化-回访客户（细分电话未接通）<br/>
                  7、优化-维护记录（主要是拜访记录）<br/>
                  8、优化-数据概览（新增回访后效果+用户活跃图）<br/>
  							</div>
  							<div class="timeline-footer"></div>
  						</div>
  					</li>
  					<!-- END timeline item -->
          <!-- timeline time label -->
  					<li class="time-label"><span class="bg-teal">
  							更新时间：2017-4-5 </span></li>
  					<li>
  						<!-- timeline icon --> <i class="fa fa-envelope bg-blue"></i>
  						<div class="timeline-item">
  							<span class="time"><i class="fa fa-clock-o"></i> 20:36</span>

  							<h3 class="timeline-header">
  								<a href="javascript:void(0)">CRM V3.0.0 更新日志</a>
  							</h3>
  							<div class="timeline-body">
  								1、重新划分菜单结构 ，精简后台功能<br/>
  								2、精简客户列表显示内容，丰富详情信息显示<br/>
  								3、回访客户试行自动推荐机制，完善回访内容项<br/>
  								4、新增客户整体数据展示，做好客户管理（维护与不维护）<br/>
  								5、独立审核操作，修改账号状态或认证状态都移到平台客户操作里面<br/>
  								6、投诉举报处理后新增短信通知举报人<br/>
                  7、修复目标管理bug、调整目标和客户等级定时更新时间<br/>
  							</div>
  							<div class="timeline-footer"></div>
  						</div>
  					</li>
  					<!-- END timeline item -->
				<!-- timeline time label -->
					<li class="time-label"><span class="bg-green">
							更新时间：2017-2-23 </span></li>
					<li>
						<!-- timeline icon --> <i class="fa fa-envelope bg-blue"></i>
						<div class="timeline-item">
							<span class="time"><i class="fa fa-clock-o"></i> 19:26</span>

							<h3 class="timeline-header">
								<a href="javascript:void(0)">CRM V2.2.0 更新日志</a>
							</h3>
							<div class="timeline-body">
								1、【目标管理】新增项，方便DCC中心对综合活跃和竞价活跃的考核<br/>
								2、【我的回访】新增部门管理页面，页面新增“任务面板”，注意权限分配<br/>
								3、【查看数据】新增用户分析，详情整合数据类型，新增投诉意见<br/>
								4、【回访该用户】新增用户id显示和跟进方式文案排序修改<br/>
								5、【小优化】修改账号状态，将以前操作备注和短信内容合并成“操作原因”<br/>
								6、【小优化】每次后台操作“启用”，程序自动更新区域分组和对应区域客服代表<br/>
							</div>
							<div class="timeline-footer"></div>
						</div>
					</li>
					<!-- END timeline item -->
				<!-- timeline time label -->
					<li class="time-label"><span class="bg-aqua">
							更新时间：2017-1-5 </span></li>
					<li>
						<!-- timeline icon --> <i class="fa fa-envelope bg-blue"></i>
						<div class="timeline-item">
							<span class="time"><i class="fa fa-clock-o"></i> 13:20</span>

							<h3 class="timeline-header">
								<a href="javascript:void(0)">CRM V2.1.0 更新日志</a>
							</h3>
							<div class="timeline-body">
								1、【优化】CRM后台框架，将员工操作功能独立出来<br/>
								2、【优化】我的回访、回访管理，便于客户代表及其主管维护客户<br/>
								3、【优化】我的审核，将小宝随行反馈信息与审核信息分开，便于400客服操作<br/>
								4、【优化】回访该用户界面，便于客户代表回访客户<br/>
								5、【新增】我的拜访及拜访该用户，便于市场部员工在家拜访<br/>
							</div>
							<div class="timeline-footer"></div>
						</div>
					</li>
					<!-- END timeline item -->
				<!-- timeline time label -->
					<li class="time-label"><span class="bg-teal">
							更新时间：2016-11-14 </span></li>
					<li>
						<!-- timeline icon --> <i class="fa fa-envelope bg-blue"></i>
						<div class="timeline-item">
							<span class="time"><i class="fa fa-clock-o"></i> 20:29</span>

							<h3 class="timeline-header">
								<a href="javascript:void(0)">CRM V2.0.0 更新日志</a>
							</h3>

							<div class="timeline-body">
								1、【新增】我的维护，员工可查看自己添加的所有维护记录<br/>
								2、【新增】潜在用户，员工可查看所有由小宝随行新增的已拜访的未注册用户，并可推广该用户<br/>
								3、【新增】不再维护（待完善）页面，员工可查看所有推广中不再维护的用户<br/>
								4、【新增】战报公告，可通过新增战报公告全屏公告战报内容<br/>
								5、【优化】回访流程，员工可在我的回访中查看到自己所有的回访用户<br/>
								6、【优化】推广流程，可自动分配用户至推广专员，员工可在我的推广中查看到自己所有的推广用户<br/>
								7、【优化】修改了所有的目录页面结构<br/>
							</div>
							<div class="timeline-footer"></div>
						</div>
					</li>
					<!-- END timeline item -->
				<!-- timeline time label -->
					<li class="time-label"><span class="bg-yellow">
							更新时间：2016-10-27 </span></li>
					<li>
						<!-- timeline icon --> <i class="fa fa-envelope bg-blue"></i>
						<div class="timeline-item">
							<span class="time"><i class="fa fa-clock-o"></i> 19:24</span>

							<h3 class="timeline-header">
								<a href="javascript:void(0)">CRM V1.5.2 更新日志</a>
							</h3>

							<div class="timeline-body">
								1、【新增】用户等级<br/>
								2、【新增】用户等级筛选<br/>
								3、【新增】用户导出excel-用户等级字段<br/>
								4、【优化】普通、竞价模式查询速度<br/>
							</div>
							<div class="timeline-footer"></div>
						</div>
					</li>
					<!-- END timeline item -->
				<!-- timeline time label -->
					<li class="time-label"><span class="bg-maroon">
							更新时间：2016-10-20 </span></li>
					<li>
						<!-- timeline icon --> <i class="fa fa-envelope bg-blue"></i>
						<div class="timeline-item">
							<span class="time"><i class="fa fa-clock-o"></i> 19:31</span>

							<h3 class="timeline-header">
								<a href="javascript:void(0)">CRM V1.5.0 更新日志</a>
							</h3>

							<div class="timeline-body">
								1、【新增】门店系统，可将用户归于门店，门店归于商家（营业执照）<br/>
								2、【新增】用户信息审核流程，最大程度保证用户信息的正确性<br/>
								3、【新增】拜访功能<br/>
								4、【新增】陪访功能<br/>
								5、【优化】用户中心模块数据展示<br/>
								6、【优化】用户导出，增加宝豆相关统计<br/>

							</div>
							<div class="timeline-footer"></div>
						</div>
					</li>
					<!-- END timeline item -->

					<!-- timeline time label -->
					<li class="time-label"><span class="bg-fuchsia">
							更新时间：2016-9-26 </span></li>
					<li>
						<!-- timeline icon --> <i class="fa fa-envelope bg-blue"></i>
						<div class="timeline-item">
							<span class="time"><i class="fa fa-clock-o"></i> 21:32</span>

							<h3 class="timeline-header">
								<a href="javascript:void(0)">CRM V1.4.0更新日志</a>
							</h3>

							<div class="timeline-body">
								1.【新增】普通模式，合并普通寻车、普通报价，并展示由普通寻车、普通报价生成的订单详情<br />
								2.【新增】竞价模式，合并竞价寻车、竞价报价、竞价订单，并展示竞价寻车从发布到结束的所有流程<br />
								3.【优化】老客服不再管辖该区域时，新客服可直接修改名字直接使用原客服账号<br />
								4.【优化】系统界面整体样式和界面的跳转<br /> 5.【优化】修改若干bug<br />
							</div>
							<div class="timeline-footer"></div>
						</div>
					</li>
					<!-- END timeline item -->

					<!-- timeline time label -->
					<li class="time-label"><span class="bg-orange">
							更新时间：2016-9-7 </span></li>
					<li>
						<!-- timeline icon --> <i class="fa fa-envelope bg-blue"></i>
						<div class="timeline-item">
							<span class="time"><i class="fa fa-clock-o"></i> 20:13</span>

							<h3 class="timeline-header">
								<a href="javascript:void(0)">CRM V1.3.0更新日志</a>
							</h3>

							<div class="timeline-body">
								1.【新增】回访目标页面的查看下属功能<br /> 2.【新增】推广目标页面的查看下属功能<br />
								3.【新增】不再维护（启用）页面<br /> 4.【新增】不再维护（停用）页面<br />
								5.【新增】平台用户页面的查看客户数据详情功能<br /> 6.【新增】查看客户数据页面<br />
								7.【优化】修改若干bug<br />
							</div>
							<div class="timeline-footer"></div>
						</div>
					</li>
					<!-- END timeline item -->

					<!-- timeline time label -->
					<li class="time-label"><span class="bg-red">
							更新时间：2016-8-30 </span></li>
					<li>
						<!-- timeline icon --> <i class="fa fa-envelope bg-blue"></i>
						<div class="timeline-item">
							<span class="time"><i class="fa fa-clock-o"></i> 21:11</span>

							<h3 class="timeline-header">
								<a href="javascript:void(0)">CRM V1.2.3 更新日志</a>
							</h3>

							<div class="timeline-body">
								1.【新增】平台用户搜索条件“推广专员”<br /> 2.【新增】平台用户筛选条件“有无推广”<br />
								3.【新增】查看认证详情功能，可查看认证资料<br /> 4.【新增】停用用户发送短信功能<br />
								5.【新增】用户得到宝豆总数、消耗宝豆总数、可用宝豆总数统计<br /> 6.【新增】维护记录页面用户搜索功能<br />
								7.【新增】更新日志页面<br /> 8.【优化】新增启用回访页面<br /> 9.【优化】新增推广回访页面<br />
								10.【优化】修改用户状态选中短信后，自动添加修改原因<br />
								11.【优化】用户审核状态改变后，取消对应的推广时间或者回访时间<br />
							</div>
							<div class="timeline-footer"></div>
						</div>
					</li>
					<!-- END timeline item -->

					<!-- timeline time label -->
					<li class="time-label"><span class="bg-green">
							更新时间：2016-8-26 </span></li>
					<li>
						<!-- timeline icon --> <i class="fa fa-envelope bg-blue"></i>
						<div class="timeline-item">
							<span class="time"><i class="fa fa-clock-o"></i> 21:15</span>

							<h3 class="timeline-header">
								<a href="javascript:void(0)">CRM V1.2.2 更新日志</a>
							</h3>

							<div class="timeline-body">
								1.【优化】修改若干bug<br />
							</div>
							<div class="timeline-footer"></div>
						</div>
					</li>
					<!-- END timeline item -->

					<!-- timeline time label -->
					<li class="time-label"><span class="bg-teal">
							更新时间：2016-8-24 </span></li>
					<li>
						<!-- timeline icon --> <i class="fa fa-envelope bg-blue"></i>
						<div class="timeline-item">
							<span class="time"><i class="fa fa-clock-o"></i> 19:16</span>

							<h3 class="timeline-header">
								<a href="javascript:void(0)">CRM V1.2.1 更新日志</a>
							</h3>

							<div class="timeline-body">
								1、【优化】修改直辖市出现没有默认选中当前市的bug<br />
								2、【优化】在后台注册的时候不用手动分组和分配任务，采用自动分组自动分配任务<br />
								3、【优化】修补添加待完善回访的时候一直提示该用户已不属于你，本来是属于他的<br />
								4、【优化】当删除账号，添加业务校验，如果该账号有负责地域，则应先解除再允许其删除账号<br /> 5、【优化】平台用户模块
								添加设置完客服不自动清除选项，设置完时间才清空选择（方便操作）<br /> 6、【优化】地址信息
								加载的时候初始化（为了解决省太窄的bug） <br /> 7、【优化】修改用户模块
								将地址设置成只读模式，修补弹出修改地址的时候地址清空的情况 <br /> 8、【优化】平台用户模块 修改文案
								设置回访任务->设置回访时间 设置推广任务->设置推广时间 <br /> 9、【优化】将几天后再拜访的计算时间放到js中
								修补领用过程中没有检查是否已被领用的bug<br /> 10、【优化】认领标记客户
								自己认领的推广或回访没有立即显示在推广回访列表中 原因：没有添加时间（默认当前时间）<br />
								11、【优化】主管设置时间的时候可以设置已经填写了回访记录约定的时间<br /> 12、【优化】在平台用户显示下次回访时间<br />
							</div>
							<div class="timeline-footer"></div>
						</div>
					</li>
					<!-- END timeline item -->

				</ul>

			</div>
		</div>

	</div>
	<!-- /.box-body -->

</div>
</template>
<script>
export default {
  name: 'update-log',
  data: function () {
    return {
      description: 'one'
    }
  }

}
</script>
